import http from '@/assets/js/interceptor';

export const getHasSelectPerson = (data) => {
  return http.post('/v1/role/roleUsers', data);
};

export const getRoleAppRowRuleApi = (data) => {
  return http.post('/v1/role/roleAppRowRule', data);
};

/**
 * 提交角色数据列权限，全局
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const submitRoleAppRowRuleApi = (data) => {
  return http.post('/v1/role/editAppRowRule', data);
};
